import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA installability + offline shell.
// Skipped on localhost so dev hot-reload is unaffected.
if ("serviceWorker" in navigator && window.location.hostname !== "localhost") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Check for updates immediately on every page load so a fixed SW takes
        // over the next navigation instead of waiting a day or two.
        reg.update().catch(() => {});
        // When a new SW takes control, hard-reload once so the page is served
        // by the up-to-date worker (and fresh JS bundle).
        let reloaded = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });
      })
      .catch((err) => console.warn("SW registration failed:", err));
  });
}
